import { render, staticRenderFns } from "./VersionControlPopup.vue?vue&type=template&id=3da68b89&scoped=true"
import script from "./VersionControlPopup.vue?vue&type=script&lang=js"
export * from "./VersionControlPopup.vue?vue&type=script&lang=js"
import style0 from "./VersionControlPopup.vue?vue&type=style&index=0&id=3da68b89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da68b89",
  null
  
)

export default component.exports